import React from "react";
import { useSelector } from "react-redux";

import { TOOL_TEMPLATE } from "../../constant/common";
import { useCompanySettings, useTemplateSetting } from "../../hooks/useCompanySettings";
import { useInstrument } from "../../hooks/useInstruments";
import i18n from "../../locale/i18n";

import { instrumentDataAndSettingSelector } from "../../store/slice/trade";
import { formatDateTime, replaceKey } from "../../utils";
import TickerName from "../TickerName/TickerName";

export default function TickerArea() {
  const [{ selectedInstrument }] = useInstrument();
  const settings = useCompanySettings();
  const template  = useTemplateSetting();
  const instrumentDataAndSetting = useSelector(instrumentDataAndSettingSelector);

  const startingDate =
    instrumentDataAndSetting[selectedInstrument.instrumentId]?.setting?.limitStartingData ||
    selectedInstrument.startingDate;
  // const dateTime = template === TOOL_TEMPLATE.victor ? selectedInstrument.lastUpdatedDate : startingDate;
  const dateTime = startingDate;
  let isLongDate = true;
  const label = template === TOOL_TEMPLATE.victor ? "updateOn" : "dataStarting";
  if (label === "dataStarting") {
    isLongDate = false;
  }

  const isNotAllowShow = (settings.instruments?.length > 1 && template === TOOL_TEMPLATE.victor);

  if (!selectedInstrument.shareName || isNotAllowShow) return null;

  return (
    <div className="ticker-area">
      <div className="ticker-area__detail">
        <h2 className="ticker-area__names">
          <TickerName
            shareName={selectedInstrument.shareName}
            marketAbbreviation={selectedInstrument.marketAbbreviation}
          />
        </h2>
        {!!selectedInstrument.startingDate && (
          <p className="ticker-area__last-trades">
            {replaceKey(i18n.translate(label), [formatDateTime(dateTime, settings, isLongDate)])}
          </p>
        )}
      </div>
    </div>
  );
}
